// extracted by mini-css-extract-plugin
export var container = "fx_c";
export var contentLeft = "fx_gg";
export var contentRight = "fx_cF";
export var divider = "fx_h3";
export var footerGridBottom = "fx_l8";
export var termsContainer = "fx_l9";